<template>
  <div>
    <b-modal
      modal-class="client-form-modal"
      body-class="bg-white p-0"
      footer-class="bg-extra-light-gray"
      v-model="editorShown"
      :title="''"
      @ok="submitUb04"
      size="lg"
      centered
      no-close-on-backdrop
      header-bg-variant="primary"
      header-text-variant="white"
      header-class="bg-purple"
    >
      <template v-slot:modal-header>
        <div
          class="w-100 d-flex flex-row justify-content-between align-items-center"
        >
          <h5 class="modal-title">UB04 Charge</h5>
          <div class="d-flex align-items-center">
            <button
              type="button"
              aria-label="Close"
              class="close text-white"
              @click="$emit('onModify')"
            >
              ×
            </button>
          </div>
        </div>
      </template>

      <template v-slot:modal-footer>
        <div class="d-flex justify-content-end align-items-center w-100">
          <div class="text-center mt-1 mr-2">
            <b-button @click="$emit('onModify')" variant="secondary"
              >Close</b-button
            >
            <b-button class="ml-2" variant="success" @click="submitUb04"
              >Submit for billing</b-button
            >
          </div>
        </div>
      </template>
      <div
        v-if="encounter"
        class="position-relative container my-3 px-0 w-100"
        :style="`max-width: 1340px;`"
      >
        <b-row>
          <b-col cols="8">
            <b-row>
              <b-col>
                <div class="d-flex justify-content-between">
                  <div class="d-flex flex-column">
                    <span>Patient</span>
                    <span>{{ encounter.mrnEocn }} {{ encounter.patient }}</span>
                  </div>
                  <div class="d-flex flex-column">
                    <span>Date of Service</span>
                    <span>{{ dateOfService }}</span>
                  </div>
                  <div class="d-flex flex-column">
                    <b-form-group style="width: 300px" label="Provider*">
                      <template v-slot:label>
                        Provider <span class="text-danger">*</span>
                      </template>
                      <v-select
                        :options="users"
                        v-model="form.providerId"
                        label="label"
                        :reduce="provider => provider.value"
                      />
                    </b-form-group>
                  </div>
                  <div class="d-flex flex-column">
                    <b-form-group
                      label="Type of Bill*"
                      :state="formErrors.typeOfBill.length == 0 ? null : false"
                      :invalid-feedback="formErrors.typeOfBill.join(', ')"
                    >
                      <template v-slot:label>
                        Type of Bill <span class="text-danger">*</span>
                      </template>
                      <b-input-group>
                        <b-form-input
                          v-model="typeOfBill"
                          size="sm"
                          style="width: 120px"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-dropdown
                            class="type-of-bill-dropdown"
                            ref="billingTypeDropdown"
                            size="sm"
                            variant="link"
                            toggle-class="text-decoration-none"
                            no-caret
                            boundary="window"
                            @show="textAutopopulateSearch = ''"
                          >
                            <template #button-content>
                              <i class="fa fa-search" aria-hidden="true"></i
                              ><span class="sr-only">Search</span>
                            </template>
                            <b-dropdown-form
                              style="
                                width: 250px;
                                height: 250px;
                                overflow: auto;
                              "
                              class="m-2"
                            >
                              <div class="table-text-autopopulate-container">
                                <b-form-input
                                  placeholder="Search..."
                                  size="sm"
                                  class="mb-2"
                                  v-model="textAutopopulateSearch"
                                />
                                <div class="table-text-autopopulate">
                                  <b-table
                                    striped
                                    hover
                                    :items="
                                      filterAutopopulateOptions(
                                        codes.billingTypeCodes
                                      )
                                    "
                                    :fields="['code', 'description']"
                                    style="font-size: 13px"
                                    @row-clicked="
                                      item => {
                                        (this.typeOfBill = item.code) &&
                                          this.$refs.billingTypeDropdown.hide();
                                      }
                                    "
                                  >
                                    <template #table-colgroup="scope">
                                      <col
                                        v-for="field in scope.fields"
                                        :key="field.key"
                                        :style="{
                                          width:
                                            field.key === 'code'
                                              ? '27%'
                                              : 'auto'
                                        }"
                                      />
                                    </template>
                                    <template #cell()="row">
                                      <div
                                        @click="updateTypeOfBill(row)"
                                        class="tableDescription"
                                      >
                                        {{ row.value }}
                                      </div>
                                    </template>
                                  </b-table>
                                </div>
                              </div>
                            </b-dropdown-form>
                          </b-dropdown>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <b-form-group
                  label="Statement Covers Period From*"
                  :state="
                    formErrors.statementCoversPeriodFrom.length == 0
                      ? null
                      : false
                  "
                  :invalid-feedback="
                    formErrors.statementCoversPeriodFrom.join(', ')
                  "
                >
                  <template v-slot:label>
                    Statement Covers Period From
                    <span class="text-danger">*</span>
                  </template>
                  <date-picker
                    size="sm"
                    v-model="form.statementCoversPeriodFrom"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group
                  label="Statement Covers Period Through*"
                  :state="
                    formErrors.statementCoversPeriodThrough.length == 0
                      ? null
                      : false
                  "
                  :invalid-feedback="
                    formErrors.statementCoversPeriodThrough.join(', ')
                  "
                >
                  <template v-slot:label>
                    Statement Covers Period Through
                    <span class="text-danger">*</span>
                  </template>
                  <date-picker
                    size="sm"
                    v-model="form.statementCoversPeriodThrough"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="Authorization Number">
                  <b-form-input
                    size="sm"
                    v-model="authorizationNumber"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mt-2">
              <b-col>
                <table-crud
                  title="Revenue codes"
                  :fields="revenueTableFields"
                  v-model="form.billingCodes"
                />
                <span
                  class="text-danger"
                  v-if="formErrors.billingCodes.length > 0"
                >
                  {{ formErrors.billingCodes[0] }}</span
                >
              </b-col>
            </b-row>
            <div class="d-flex justify-content-end my-2">
              <span style="font-size: 14px"
                >Total: {{ toCurrencyValue(revenueTotalAmount) }}</span
              >
            </div>
            <b-row class="mt-2" align-h="around">
              <b-col cols="5">
                <table-crud
                  :fields="occurrenceCodesFields"
                  title="Occurrence codes"
                  v-model="form.occurrenceCodes"
                />
              </b-col>
              <b-col cols="7">
                <table-crud
                  :fields="occurrenceSpanCodesFields"
                  title="Occurrence span codes"
                  v-model="form.occurrenceSpanCodes"
                />
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="5">
                <span
                  class="text-danger"
                  v-if="formErrors.valueCodes.length > 0"
                >
                  {{ formErrors.valueCodes[0] }}</span
                >
                <table-crud
                  :fields="valueCodesFields"
                  title="Value codes"
                  v-model="form.valueCodes"
                />
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="4">
            <b-form-group label="Diagnosis codes*">
              <template v-slot:label>
                Diagnosis codes <span class="text-danger">*</span>
              </template>
              <multiple-select
                :options="icdCodes"
                v-model="icdCodeIds"
                :search="
                  (search, loading) => fetchIcdCodeOptions(search, loading)
                "
                :disableFilter="true"
                placeholder="Search for ICD Codes"
                :onDemand="true"
                :disableCache="true"
              />
            </b-form-group>
            <patient-insurances
              :insurances="encounter.insuranceCompanies"
              :eocInsurances="eocInsurances"
              :eocBillType="encounter.patientBillType"
              @formPatientInsurancesData="addPatientInsurancesData"
            ></patient-insurances>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { formatDateOnly } from "../../../helpers/date";
import TableCrud from "../../controls/TableCrud.vue";
import {
  validateDate,
  validateRequired,
  validateLengthGreaterEqualThan
} from "../../../helpers/validation";
import billingServer from "../../../server/billing";
import { validateEncountersForSubmit } from "../../../helpers/encounter";
import { mapActions } from "vuex";
import userServer from "../../../server/user";
import DatePicker from "../../controls/DatePicker.vue";
import icdCodeServer from "../../../server/icdCode";
import MultipleSelect from "../../controls/MultipleSelect.vue";
import PatientInsurances from "../../../components/episode_of_care/PatientInsurances.vue";

export default {
  name: "BillingUB04ChargeAddModal",
  components: { TableCrud, DatePicker, MultipleSelect, PatientInsurances },
  props: ["encounterId"],
  data() {
    return {
      encounter: null,
      form: {
        statementCoversPeriodFrom: null,
        statementCoversPeriodThrough: null,
        billingCodes: [],
        occurrenceCodes: [],
        occurrenceSpanCodes: [],
        valueCodes: []
      },
      formErrors: {
        typeOfBill: [],
        statementCoversPeriodFrom: [],
        statementCoversPeriodThrough: [],
        valueCodes: [],
        billingCodes: []
      },
      codes: [],
      textAutopopulateSearch: "",
      typeOfBill: null,
      icdCodes: [],
      icdCodeIds: [],
      services: [],
      authorizationNumber: "",
      formPatientInsurances: {},
      eocInsurances: null
    };
  },
  async mounted() {
    await this.fetchUsers();
    await this.fetchEncounter();
    this.fetchUb04Codes();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess", "showError"]),
    addPatientInsurancesData(data) {
      this.formPatientInsurances.primaryPatientInsuranceId =
        data.insurancePrimary.value;
      this.formPatientInsurances.secondaryPatientInsuranceId =
        data.insuranceSecundary.value;
      this.formPatientInsurances.tertiaryPatientInsuranceId =
        data.insuranceTertiary.value;
      this.formPatientInsurances.billTypes = data.billTypes;
    },
    async fetchEncounter() {
      let result = await billingServer.get(this.encounterId);

      this.encounter = result;
      this.form = {
        ...this.encounter.uB04,
        billingCodes:
          this.encounter.uB04.billingCodes.length > 0
            ? this.encounter.uB04.billingCodes.map(billCode => ({
                ...billCode,
                cptCode: billCode.cptCode ?? "",
                hcpcsCode: billCode.hcpcsCode ?? "",
                revenueCode: billCode.revenueCode ?? ""
              }))
            : [{}],
        occurrenceCodes:
          this.encounter.uB04.occurrenceCodes.length > 0
            ? this.encounter.uB04.occurrenceCodes
            : [{}],
        occurrenceSpanCodes:
          this.encounter.uB04.occurrenceSpanCodes.length > 0
            ? this.encounter.uB04.occurrenceSpanCodes
            : [{}],
        valueCodes:
          this.encounter.uB04.valueCodes.length > 0
            ? this.encounter.uB04.valueCodes
            : [{}],
        providerId: this.encounter.providerId
      };
      this.typeOfBill = result.uB04.typeOfBill;

      this.icdCodeIds = this.encounter.diagnosisCodes.map(icdCode => ({
        value: icdCode.id,
        label: `${icdCode.code} - ${icdCode.description}`,
        data: icdCode
      }));
      this.authorizationNumber = this.encounter.authorizationNumber;
      this.eocInsurances = {
        id: this.encounter.scheduleEventParticipantId,
        insurancePrimary: this.encounter.scheduleEventParticipantInsurances
          .insurancePrimary,
        insuranceSecundary: this.encounter.scheduleEventParticipantInsurances
          .insuranceSecundary,
        insuranceTertiary: this.encounter.scheduleEventParticipantInsurances
          .insuranceTertiary
      };
    },
    fetchUb04Codes() {
      billingServer.getUb04Codes().then(data => {
        this.codes = data;
      });
    },
    submitUb04() {
      this.$dialog
        .confirm(
          { title: "Are you sure you want to submit this charge?" },
          { view: "confirm" }
        )
        .then(async () => {
          const errors = validateEncountersForSubmit([
            {
              ...this.encounter,
              diagnosisCodes: this.icdCodeIds,
              provider: this.form.providerId
            }
          ]);
          if (errors.length) {
            this.showError({
              message: "Errors: \r\n" + errors.join("\r\n"),
              multiline: true
            });
            return;
          }
          if (this.validateData()) {
            await billingServer.updateUb40Charge(this.encounterId, {
              ...this.form,
              typeOfBill: this.typeOfBill,
              valueCodes: this.form.valueCodes
                .filter(vc => Object.entries(vc).length > 0)
                .map(valueCode => ({
                  ...valueCode,
                  amount: valueCode.amount
                    ? parseFloat(valueCode.amount.toString())
                    : 0
                })),
              occurrenceCodes: this.form.occurrenceCodes.filter(
                oc => Object.entries(oc).length > 0
              ),
              occurrenceSpanCodes: this.form.occurrenceSpanCodes.filter(
                osc => Object.entries(osc).length > 0
              ),
              diagnosisCodes: this.icdCodeIds.map(x => x.value),
              billingCodes: this.form.billingCodes.map(bc => {
                return {
                  ...bc,
                  costPerUnit: parseFloat(bc.costPerUnit),
                  numberOfUnits: parseFloat(bc.numberOfUnits),
                  serviceId:
                    bc.serviceId !== undefined
                      ? bc.serviceId
                      : this.form.billingCodes[0].serviceId,
                  scheduleEventId:
                    bc.scheduleEventId !== undefined
                      ? bc.scheduleEventId
                      : this.encounter.scheduleEventId
                };
              }),
              authorizationNumber: this.authorizationNumber,
              scheduleEventParticipant: {
                primaryPatientInsuranceId: this.formPatientInsurances
                  .primaryPatientInsuranceId,
                secondaryPatientInsuranceId: this.formPatientInsurances
                  .secondaryPatientInsuranceId,
                tertiaryPatientInsuranceId: this.formPatientInsurances
                  .tertiaryPatientInsuranceId,
                billTypes: this.formPatientInsurances.billTypes ? 0 : 1
              }
            });

            this.$emit("onModify");
          }
        })
        .catch(function() {});
    },
    validateData() {
      let result = true;

      this.formErrors.typeOfBill = [];
      if (
        !validateRequired(this.typeOfBill) ||
        !validateLengthGreaterEqualThan(this.typeOfBill, 4)
      ) {
        this.formErrors.typeOfBill.push(
          "This field must be at least 4 characters"
        );
        result = false;
      }
      this.formErrors.statementCoversPeriodFrom = [];
      if (
        this.formErrors.statementCoversPeriodFrom &&
        !validateDate(this.form.statementCoversPeriodFrom)
      ) {
        this.formErrors.statementCoversPeriodFrom.push(
          "This field must be a valid date"
        );
        result = false;
      }
      this.formErrors.statementCoversPeriodThrough = [];
      if (
        this.formErrors.statementCoversPeriodThrough &&
        !validateDate(this.form.statementCoversPeriodThrough)
      ) {
        this.formErrors.statementCoversPeriodThrough.push(
          "This field must be a valid date"
        );
        result = false;
      }

      this.formErrors.billingCodes = [];
      if (this.form.billingCodes.length > 0) {
        this.form.billingCodes.forEach(code => {
          if (!code.costPerUnit || !code.numberOfUnits) {
            this.formErrors.billingCodes.push(
              "You have a revenue code entry without cost or amount!"
            );
            result = false;
          }
          if (
            (code.costPerUnit && code.costPerUnit < 0) ||
            (code.numberOfUnits && code.numberOfUnits < 0)
          ) {
            this.formErrors.billingCodes.push(
              "Numeric field must have a positive value!"
            );
            result = false;
          }
        });
      }

      return result;
    },
    async fetchUsers() {
      const users = await userServer.getMinimalUsers({
        overrideAccessToLocations: true
      });
      this.users = users
        .filter(user => user.providerInfo)
        .map(user => ({
          value: user.id,
          label: this.formatUser(user),
          data: user
        }));
    },
    filterAutopopulateOptions(options) {
      let result = options;
      if (this.textAutopopulateSearch) {
        result = options.filter(
          option =>
            option.code
              .toLowerCase()
              .includes(this.textAutopopulateSearch.toLowerCase()) ||
            option.description
              .toLowerCase()
              .includes(this.textAutopopulateSearch.toLowerCase())
        );
      }
      return result;
    },
    updateTypeOfBill(data) {
      this.$refs.billingTypeDropdown.hide();
      this.typeOfBill = data.item.code;
    },
    async fetchIcdCodeOptions(search, loading) {
      if (this.IcdCodesTimeout) {
        clearTimeout(this.IcdCodesTimeout);
        this.IcdCodesTimeout = null;
      }
      if (search && search.trim().length >= 3) {
        this.icdCodes = [];
      }

      this.IcdCodesTimeout = setTimeout(async () => {
        loading(true);
        if (search.trim().length >= 3) {
          const icdCodes = await icdCodeServer.query(
            { searchPhrase: search },
            {
              "Hide-Loading": true
            }
          );
          this.icdCodes = icdCodes.map(icdCode => ({
            value: icdCode.id,
            label: `${icdCode.code} - ${icdCode.description}`,
            data: icdCode
          }));
        } else this.icdCodes = [];
        loading(false);
      }, 1000);
    }
  },
  computed: {
    buttonDisabled() {
      return this.form.typeOfBill.length > 0 ? true : false;
    },
    dateOfService() {
      return formatDateOnly(this.encounter.date);
    },
    revenueTableFields() {
      return [
        {
          field: "revenueCode",
          text: "Revenue Code",
          type: "text_autopopulate",
          options: this.codes.revenueCodes
        },
        {
          field: "hcpcsCode",
          text: "HPCS Code",
          type: "text"
        },
        {
          field: "mod1",
          text: "M1",
          type: "text"
        },
        {
          field: "mod2",
          text: "M2",
          type: "text"
        },
        {
          field: "mod3",
          text: "M1",
          type: "text"
        },
        {
          field: "mod4",
          text: "M4",
          type: "text"
        },
        {
          field: "costPerUnit",
          text: "Cost/Unit($)",
          type: "number"
        },
        {
          field: "numberOfUnits",
          text: "Number of units",
          type: "number"
        }
      ];
    },
    occurrenceCodesFields() {
      return [
        {
          field: "code",
          text: "Code",
          type: "text_autopopulate",
          options: this.codes.occurrenceCodes
        },
        {
          field: "date",
          text: "Date",
          type: "date"
        }
      ];
    },
    occurrenceSpanCodesFields() {
      return [
        {
          field: "code",
          text: "Code",
          type: "text_autopopulate",
          options: this.codes.occurrenceSpanCodes
        },
        {
          field: "from",
          text: "From",
          type: "date"
        },
        {
          field: "through",
          text: "Through",
          type: "date"
        }
      ];
    },
    valueCodesFields() {
      return [
        {
          field: "code",
          text: "Code",
          type: "text_autopopulate",
          options: this.codes.valueCodes
        },
        {
          field: "amount",
          text: "Amount",
          type: "number"
        }
      ];
    },
    revenueTotalAmount() {
      let total = 0;
      for (let index = 0; index < this.form.billingCodes.length; index++) {
        const billingCode = this.form.billingCodes[index];
        if (billingCode.numberOfUnits && billingCode.costPerUnit) {
          total += billingCode.numberOfUnits * billingCode.costPerUnit;
        }
      }
      return total;
    },
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  watch: {
    "form.billingCodes": {
      handler(val) {
        for (let i = 0; i < val.length; i++) {
          if (!val[i].serviceId) {
            this.$set(val[i], "serviceId", this.encounter.services[0].id);
          }
        }
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.modal >>> .modal-dialog {
  background-color: rebeccapurple;
}

.modal-dialog::v-deep {
  max-width: 1280px !important;
}
.section-body {
  min-height: 70px;
}
.modal-col {
  margin: 20px;
}
.badge-fixed-size {
  min-width: 101px;
  margin: 0 10px;
}
.add-button {
  max-height: 35px;
  margin: 30px 10px;
}
.type-of-bill-dropdown >>> ul {
  left: -142px !important;
}
.tableDescription {
  cursor: pointer;
}
.table-text-autopopulate-container >>> .table th,
.table-text-autopopulate-container >>> .table td {
  padding: 5px 12px !important;
}
.table-text-autopopulate-container >>> .table tr {
  cursor: pointer;
}
.table-text-autopopulate {
  overflow-y: auto !important;
  max-height: 200px !important;
}
</style>
